// @ts-nocheck
import React, { createRef } from "react";
import { Modal, Input } from "antd";
import BaseComponent from "../../../../base/common/BaseComponent";
import ProcedureBlock from "../../../../base/basicComponents/procedureBlock";
import PageHeader from "../../../commonComponents/pageHeaders/PageHeader";
import TaskInformation from "../../../sections/taskInfoSections";
import ProcedureInformation from "../../../sections/procedureInfoSections/readOnlyProcedureInfoSection";
import ReadOnlyProcedureFileSection from "../../../sections/procedureFileSections/readOnlyProcedureFileSection";
import ReadOnlySupportingFileSection from "../../../sections/supportingFileSections/readOnlySupportingFileSection";
import InputLabel from "../../../../base/basicComponents/inputLabel";
import Buttons from "../../../../base/basicComponents/button";
import { ModalWithComponent } from "../../../../base/basicComponents/modal";
import { actions, shareTaskMassage } from "../../../publicDictionaryValues";
import approveShareService from "../../../../service/shareTask/approveShareService";
import ReviseShareTask from "../../../sections/sharedTaskSections/reviseShareTask";
import NormalModel from "../../../../base/basicComponents//modal/index";
import styles from "../../procedureFileProcess/style/index.module.scss";
import reviseShareService from "../../../../service/shareTask/reviseShareService";
import shareTaskService from "../../../../service/shareTask";
import appService from "../../../../service/app";
import LostPermissionModal from "../../../sections/lostPermissionModal";

import StepBusinessType from "../../../../service/stepBase/stepBusinessType";
import StepService from "../../../../service/stepBase/StepService";
import { disableInteraction } from "utils/index";

const procedureReturnAddFileRef = createRef();
const procedureFileRef = createRef();
const reviseShareTaskRef = createRef();
const supportingFileRef = createRef();
const supportingFileTableRef = createRef();

export default class ReviseShareTaskProcess extends BaseComponent {
  constructor(props: any) {
    super(props);
    this.state = {
      pageState: this.initReviseShareTaskPageState(),
      modalState: this.initReviseShareTaskModalState(),
      returnOrRejectInputStatus: "",
      returnOrRejectInputValue: "",
      returnOrRejectModalTitle: "",
      isReturnOrRejectModalOpen: false,
      confirmModalText: "",
      isApproveComfirmOpen: false,
      handleApproveComfirm: () => {
        //this is a empty function
      },
      noPermission: false,
    };
    // @ts-ignore
    this.isTableBorderError = false;
    // @ts-ignore
    this.para = null;
    // @ts-ignore
    this.params = {
      TaskId: this.props.params.ProcedureTaskId,
      ProcedureID: this.props.params.ProcedureID,
      ProcedureStepID: this.props.params.ProcedureStepID,
    };
  }

  initReviseShareTaskPageState = () => {
    return {
      rejectReason: this.props.pageProps.rejectReason,
      rejectStatus: this.props.pageProps.rejectStatus,
      isCancelDisabled: false,
      isSubmitDisabled: false,
      isRejectDisabled: false,
      isTableBorderError: false,
      isChange: false,
    };
  };

  initReviseShareTaskModalState = () => {
    return {
      modalTitle: "",
      modalLabel: "",
      okText: "",
      cancelText: "",
      closable: false,
      isOkBtnDisabled: false,
      isCancelBtnDisabled: false,
      maskClosable: false,
      isModalWithComponentOpen: false,
      isShowSelect: false,
      rowIndex: 0,
      fileIds: [],
      fileNames: [],
      modalWidth: 520,
    };
  };

  reviseShareTaskCancelConfirm = () => {
    this.setState({
      isApproveComfirmOpen: false,
    });
    // @ts-ignore
    reviseShareTaskRef.current.resetReviseData();
    this.props.closePage();
  };

  handleReviseShareTaskCancel = () => {
    this.setState({
      isApproveComfirmOpen: true,
      confirmModalText: "Are you sure to quit without saving?",
      handleApproveComfirm: this.reviseShareTaskCancelConfirm,
    });
  };

  transReviseShareTaskFormData = (data: any) => {
    if (data === undefined) {
      return null;
    }
    const outputData = data.map((obj: any) => {
      if (obj.hasOwnProperty("isDeleted")) {
        obj.isDel = obj.isDeleted;
        delete obj.isDeleted;
      }
      return obj;
    });

    return outputData;
  };

  handleReviseShareTaskSubmitPara = (actionID: any, actionName: any) => {
    return {
      actionName: actionName,
      actionID: actionID,
      rejectReason: this.state.pageState.rejectReason,
      procedureProcessId: this.props.shareTaskData.procedureProcessID,
      workflowProcessInstanceId: this.props.params.WorkflowProcessInstanceId,
      flowCategoryID: this.props.params.FlowCategoryID,
      procedureStepID: this.props.params.ProcedureStepID,
      tasks: this.transReviseShareTaskFormData(
        // @ts-ignore
        JSON.parse(JSON.stringify(reviseShareTaskRef.current.state.reviseData))
      ),
      shareTaskProcedureStepId: this.props.shareTaskData.shareTaskProcedureStepID,
      // @ts-ignore
      reason: reviseShareTaskRef.current.state.reasonValue,
    };
  };

  approveSuccess = () => {
    this.props._hideLoading();
    this._alertSuccess("Revise Successful");
    this.props.closePage();
  };

  approveFailed = () => {
    this.props._hideLoading();
    this._alertError("Revise Failed");
  };

  handleApproveComfirm = () => {
    this.props._showLoading();
    this.setState({
      isApproveComfirmOpen: false,
    });
    const para = this.handleReviseShareTaskSubmitPara(actions.revise, "Revise");
    // @ts-ignore
    const deleteList = reviseShareTaskRef.current.getDeleteData();
    if (deleteList.length > 0) {
      for (let item of deleteList) {
        const para = {
          procedureTaskId: item.procedureTaskId,
          shareTaskProcedureStepId: this.props.shareTaskData.shareTaskProcedureStepID,
        };
        reviseShareService.delTaskRowInfo(
          para,
          () => {
            // this is an empty function
          },
          () => {
            // this is an empty function
          }
        );
      }
    }
    approveShareService.manageShareTaskTriggerAction(para, this.approveSuccess, this.approveFailed);
  };

  checkSubmitOnSuccess = (result: any) => {
    let currentData = JSON.parse(
      // @ts-ignore
      JSON.stringify(reviseShareTaskRef.current.state.reviseData)
    );
    if (!result.result) {
      const errorMsg =
        "There are some tasks that do not meet the conditions for adding to or removing from the sharing relationship. Please check the specific reasons in the task list.";
      this._alertError(errorMsg, 6);
      const responseData = result.resultList;
      for (let index = 0; index < currentData.length; index++) {
        const responseIndex = responseData.findIndex(
          (x: any) => x.taskId === currentData[index].taskId && !x.checkResult
        );
        if (responseIndex > -1) {
          currentData[index] = {
            ...currentData[index],
            hasError: true,
            // @ts-ignore
            errorMessage: shareTaskMassage[responseData[responseIndex].msgCode],
          };
        } else {
          currentData[index] = {
            ...currentData[index],
            hasError: false,
            errorMessage: "",
          };
        }
      }
      // @ts-ignore
      reviseShareTaskRef.current.updateReviseData(currentData);
    } else {
      const data = currentData.map((item: any) => {
        if (item.hasError === true) {
          return {
            ...item,
            hasError: false,
            errorMessage: "",
          };
        }

        return item;
      });
      // @ts-ignore
      reviseShareTaskRef.current.updateReviseData(data);

      // @ts-ignore
      if (reviseShareTaskRef.current.dataHasChange()) {
        this.setState({
          isApproveComfirmOpen: true,
          confirmModalText: "Are you sure to submit?",
          handleApproveComfirm: this.handleApproveComfirm,
        });
      } else {
        this.setState({
          isApproveComfirmOpen: true,
          confirmModalText:
            "No changes made! Are you sure to resubmit this request without any changes?",
          handleApproveComfirm: this.handleApproveComfirm,
        });
      }
    }
  };

  checkSubmitOnError = () => {
    this._alertError("Check Failed");
  };

  handleShareSubmitClick = () => {
    if (
      // @ts-ignore
      reviseShareTaskRef.current.state.resonRequired &&
      // @ts-ignore
      reviseShareTaskRef.current.state.reasonValue.trim() === ""
    ) {
      // @ts-ignore
      reviseShareTaskRef.current.updateReasonInputErrorStatus();
      return;
    }

    const currentData = this.transReviseShareTaskFormData(
      // @ts-ignore
      JSON.parse(JSON.stringify(reviseShareTaskRef.current.state.reviseData))
    );
    disableInteraction();
    const para = {
      procedureId: this.props.params.ProcedureID,
      taskList: currentData,
      procedureStepId: this.props.params.ProcedureStepID,
      checkNewTagOnly: true,
    };
    shareTaskService.checkSubmit(para, this.checkSubmitOnSuccess, this.checkSubmitOnError);
  };

  _checkStepPermissionSuccess = (result: any) => {
    this.props._hideLoading();
    const { statusCode } = result;
    const noPermission = statusCode !== 200;
    this.setState({
      noPermission,
    });
    if (noPermission) return;
    this.handleReviseSubmitClick();
  };

  checkStepPermission = () => {
    this.props._showLoading();
    const param = {
      taskID: this.props.params.ProcedureTaskId,
      procedureID: this.props.params.ProcedureID,
      procedureStepID: this.props.params.ProcedureStepID,
      parentPage: null,
    };
    appService.checkStepPermission(param, this._checkStepPermissionSuccess, (response: any) =>
      this._alertError(response.message)
    );
  };

  handleReviseSubmitClick = () => {
    this.handleShareSubmitClick();
  };

  handleApproveComfirmCancel = () => {
    this.setState({
      isApproveComfirmOpen: false,
    });
  };

  handleReviseShareTaskPageHeader = () => {
    const { receiveDate, requestByName, procedureStepStatus } = this.props.pageProps;

    return (
      <PageHeader
        title="Revise Shared Tasks"
        receiveDate={this._formateDate(receiveDate)}
        requestBy={requestByName}
        status={procedureStepStatus}
      />
    );
  };

  handleReviseShareTaskTaskInfo = () => {
    const { taskInfoData } = this.props.sectionProps;

    return (
      <ProcedureBlock
        testid="task-info-block-arrow"
        className={styles.approveProcedureBlock}
        child={<TaskInformation data={taskInfoData} />}
        isShowArrow={true}
        isOpen={false}
        onShowDataLoad={() => {
          return StepService.getStepData(
            // @ts-ignore
            this.params,
            this.props.setTaskInfoData,
            this.setError,
            [StepBusinessType.taskInfo],
            StepService.getMergePayloadBySettingKey([StepBusinessType.taskInfo.settingKey])
          );
        }}
      />
    );
  };

  handleReviseShareProcedureFileSection = () => {
    const { fileTableData, jbProcedureSavedIn, serverPathValue, savedInRadioValue } = this.props;

    return (
      <ProcedureBlock
        testid="procedure-file-block-arrow"
        className={styles.approveProcedureBlock}
        child={
          <ReadOnlyProcedureFileSection
            procedureFileRef={procedureFileRef}
            jbProcedureSavedIn={jbProcedureSavedIn}
            clientServerPath={serverPathValue}
            savedInRadioValue={savedInRadioValue}
            procedureFileData={fileTableData !== undefined ? fileTableData : []}
          />
        }
        isShowArrow={true}
        isOpen={false}
        onShowDataLoad={() => {
          // @ts-ignore
          return StepService.getStepData(
            // @ts-ignore
            this.params,
            this.props.setProcedureFileData,
            this.setError,
            [StepBusinessType.procedureFile]
          );
        }}
      />
    );
  };

  handleReviseShareSupportingFileSection = () => {
    const { supportingTableData } = this.props;

    return (
      <ProcedureBlock
        testid="supporting-file-block-arrow"
        className={styles.approveProcedureBlock}
        child={
          <ReadOnlySupportingFileSection
            supportingFileTableRef={supportingFileTableRef}
            supportingFileRef={supportingFileRef}
            supportingFileData={supportingTableData}
          />
        }
        isShowArrow={true}
        isOpen={false}
        onShowDataLoad={() => {
          // @ts-ignore
          return StepService.getStepData(
            // @ts-ignore
            this.params,
            this.props.setSupportingFileData,
            this.setError,
            [StepBusinessType.supportingFile]
          );
        }}
      />
    );
  };

  handleReviseShareProcedureInfoSection = () => {
    const { procedureInfoData, ppoList } = this.props.sectionProps;
    const { procedureStatus } = this.props.pageProps;

    return (
      <ProcedureBlock
        testid="procedure-info-block-arrow"
        className={styles.approveProcedureBlock}
        child={
          <ProcedureInformation
            title="Procedure Information"
            procedureStatus={procedureStatus}
            isPPODisabled={true}
            noteDisabled={true}
            isShowActions={false}
            ppoList={ppoList}
            submitData={procedureInfoData}
          />
        }
        isShowArrow={true}
        isOpen={false}
        onShowDataLoad={() => {
          // @ts-ignore
          return StepService.getStepData(
            // @ts-ignore
            this.params,
            this.props.setProcedureInfoData,
            this.setError,
            [
              StepBusinessType.procedureOwner,
              StepBusinessType.pmpExcluded,
              StepBusinessType.primaryProcedureOwner,
            ]
          );
        }}
      />
    );
  };

  handleReviseShareTaskSection = () => {
    const { shareTaskData } = this.props;

    return (
      <ProcedureBlock
        testid="share-task-block-arrow"
        className={styles.approveProcedureFile}
        child={
          // @ts-ignore
          <ReviseShareTask
            ref={reviseShareTaskRef}
            procedureTaskId={this.props.params.ProcedureTaskId}
            shareTaskData={shareTaskData}
            procedureStepId={this.props.params.ProcedureStepID}
          />
        }
        isShowArrow={true}
        isOpen={true}
      />
    );
  };

  handleReviseShareTaskButton = () => {
    const { isCancelDisabled, isSubmitDisabled } = this.state.pageState;

    return (
      <div className={styles.actionBtns}>
        <div className={styles.normalBtns}>
          <Buttons
            testid="revise-share-task-cancel-btn"
            color="grey"
            size="middle"
            onClick={this.handleReviseShareTaskCancel}
            disabled={isCancelDisabled}
            btnClassName={styles.approveActionBtn}
          >
            Cancel
          </Buttons>
          <Buttons
            testid="revise-share-task-submit-btn"
            color="blue"
            size="middle"
            onClick={this.checkStepPermission}
            disabled={isSubmitDisabled}
            btnClassName={styles.approveActionSubmitBtn}
          >
            Submit for Approval
          </Buttons>
        </div>
      </div>
    );
  };

  handleReviseShareTaskModalWithComponent = () => {
    const { procedureReplaceFileRef } = this.props.pageProps;
    const {
      handleOk,
      handleCancel,
      maskClosable,
      isModalWithComponentOpen,
      rowIndex,
      fileIds,
      fileNames,
      modalTitle,
      modalLabel,
      okText,
      cancelText,
      modalWidth,
      closable,
      isOkBtnDisabled,
      isCancelBtnDisabled,
    } = this.state.modalState;

    return (
      // @ts-ignore
      <ModalWithComponent
        testid="revise-share-task-modal"
        fileUploadRef={procedureReplaceFileRef}
        fileUploadInputRef={procedureReturnAddFileRef}
        okText={okText}
        isModalOpen={isModalWithComponentOpen}
        closable={closable}
        handleOk={handleOk}
        handleCancel={handleCancel}
        maskClosable={maskClosable}
        label={modalLabel}
        isLoading={isOkBtnDisabled}
        modalWidth={modalWidth}
        rowindex={rowIndex}
        cancelText={cancelText}
        title={modalTitle}
        fileIds={fileIds}
        fileNames={fileNames}
        hideLoading={(this as any)._hideModalBtnsDisabled}
        openLoading={(this as any)._openModalBtnsDisabled}
        isOkDisabled={isOkBtnDisabled}
        isCancelDisabled={isCancelBtnDisabled}
      />
    );
  };

  handleReviseShareTaskModal = () => {
    return (
      // @ts-ignore
      <Modal
        title={
          <InputLabel
            text={this.state.returnOrRejectModalTitle}
            required={true}
            className={styles.modalText}
          />
        }
        open={this.state.isReturnOrRejectModalOpen}
        okText="Submit"
        onOk={(this as any).handleReturnOrRejectOk}
        onCancel={(this as any).handleReturnOrRejectCancel}
        maskClosable={false}
      >
        {/* @ts-ignore */}
        <Input.TextArea
          maxLength={1000}
          showCount={true}
          style={{
            height: 120,
            resize: "none",
          }}
          status={this.state.returnOrRejectInputStatus}
          onChange={(e) => (this as any).returnOrRejectInputOnChange(e.target)}
          value={this.state.returnOrRejectInputValue}
        />
      </Modal>
    );
  };

  handleReviseShareTaskNormalModel = () => {
    return (
      <NormalModel
        okText="Confirm"
        cancelText="Cancel"
        childContent={<p className="fs-16">{this.state.confirmModalText}</p>}
        isModalOpen={this.state.isApproveComfirmOpen}
        handleOk={this.state.handleApproveComfirm}
        handleCancel={this.handleApproveComfirmCancel}
      />
    );
  };

  render() {
    const { procedureStepStatus } = this.props.pageProps;

    return (
      <div className={styles.approveNewPro}>
        {this.handleReviseShareTaskPageHeader()}
        {this.handleReviseShareTaskTaskInfo()}
        {this.handleReviseShareProcedureFileSection()}
        {this.handleReviseShareSupportingFileSection()}
        {this.handleReviseShareProcedureInfoSection()}
        {this.handleReviseShareTaskSection()}
        {procedureStepStatus === "Pending" && this.handleReviseShareTaskButton()}
        {this.handleReviseShareTaskModalWithComponent()}
        {this.handleReviseShareTaskModal()}
        {this.handleReviseShareTaskNormalModel()}
        <LostPermissionModal isModalOpen={this.state.noPermission} />
      </div>
    );
  }
}
